<style scoped>
    .payment-row {
        margin-bottom: 15px;
    }
    .delivery-zones-container {
        margin-left: 30px;
    }
</style>

<template>
    <div>
        <div class="panel panel-default">
            <div class="panel-heading">{{ translations.title }}</div>
            <div class="panel-body">
                <!-- Payment zones -->
                <div class="clearfix" v-for="(payment_zone, payment_index) in editing_payment_zones">
                    <div class="row">
                        <div class="col-md-3">
                            {{ translations.payment_type }}
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.tax }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.tax_type }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.price_limit }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.price_limit_currency_id }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.seeds_count_limit }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.sorting }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.activity }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.control }}</label>
                        </div>
                        <div class="col-md-1">
                            <label>{{ translations.only_stealth }}</label>
                        </div>
                    </div>
                    <div class="row payment-row">
                        <div class="col-md-3">
                            <select class="form-control"
                                    v-model="payment_zone.payment_type_id"
                                    :name="`payment_zones[${payment_index}][payment_type_id]`"
                            >
                                <option v-for="(payment_name, payment_id) in payment_types"
                                        :value="payment_id"
                                        v-text="payment_name"
                                ></option>
                            </select>
                        </div>
                        <div class="col-md-1">
                            <input class="form-control"
                                   v-model="payment_zone.tax"
                                   :name="`payment_zones[${payment_index}][tax]`"
                            />
                        </div>
                        <div class="col-md-1">
                            <select class="form-control"
                                    v-model="payment_zone.tax_type"
                                    :name="`payment_zones[${payment_index}][tax_type]`"
                            >
                                <option v-for="tax_type in tax_types"
                                        :value="tax_type"
                                        v-html="translations.tax_types[tax_type]"
                                ></option>
                            </select>
                        </div>
                        <div class="col-md-1">
                            <input type="number" step="0.01" class="form-control" v-model="payment_zone.price_limit" :name="`payment_zones[${payment_index}][price_limit]`"/>
                        </div>
                        <div class="col-md-1">
                          <select class="form-control" v-model="payment_zone.price_limit_currency_id" :name="`payment_zones[${payment_index}][price_limit_currency_id]`">
                            <option v-for="(title, id) in currencies" :value="id" v-html="title" :selected="id == payment_zone.price_limit_currency_id"></option>
                          </select>
                        </div>
                        <div class="col-md-1">
                            <input type="number" step="1" class="form-control" v-model="payment_zone.seeds_count_limit" :name="`payment_zones[${payment_index}][seeds_count_limit]`"/>
                        </div>
                        <div class="col-md-1">
                            <input type="number" min="0"
                                   class="form-control"
                                   v-model="payment_zone.sorting"
                                   :name="`payment_zones[${payment_index}][sorting]`"
                            />
                        </div>
                        <div class="col-md-1">
                            <input type="checkbox"
                                   value="1"
                                   v-model="payment_zone.is_active"
                                   :name="`payment_zones[${payment_index}][is_active]`"
                            />
                        </div>
                        <div class="col-md-1">
                            <button @click="removePaymentZone(payment_index)" type="button" class="btn btn-danger btn-xs">
                                <i class="fa fa-ban"></i>
                            </button>
                        </div>
                        <div class="col-md-1">
                          <input type="checkbox"
                                 value="1"
                                 v-model="payment_zone.only_stealth"
                                 :name="`payment_zones[${payment_index}][only_stealth]`"
                          />
                        </div>
                    </div>

                    <!-- Delivery zones -->
                    <div class="delivery-zones-container">
                        <div class="row" v-if="payment_zone.delivery_zones.length">
                            <div class="col-md-3">
                                <label>{{ translations.delivery_type }}</label>
                            </div>
                            <div class="col-md-2">
                                <label>{{ translations.delivery_tariffs }}</label>
                            </div>
                            <div class="col-md-2">
                                <label>{{ translations.tax }}</label>
                            </div>
                            <div class="col-md-1">
                                <label>{{ translations.sorting }}</label>
                            </div>
                            <div class="col-md-1">
                                <label>{{ translations.min_delivery_days }}</label>
                            </div>
                            <div class="col-md-1">
                                <label>{{ translations.max_delivery_days }}</label>
                            </div>
                            <div class="col-md-1">
                                <label>{{ translations.activity }}</label>
                            </div>
                            <div class="col-md-1">
                                <label>{{ translations.control }}</label>
                            </div>
                        </div>
                        <div v-for="(delivery_zone, delivery_index) in payment_zone.delivery_zones" class="row payment-row">
                            <div class="col-md-3">
                                <select class="form-control input-sm"
                                        v-model="delivery_zone.delivery_type_id"
                                        :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][delivery_type_id]`"
                                >
                                    <option v-for="type in delivery_types"
                                            :value="type.id"
                                            v-text="type.name"
                                    ></option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <select class="form-control input-sm"
                                        :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][delivery_tariff_id]`"
                                        v-if="delivery_zone.delivery_type_id"
                                        v-model="delivery_zone.delivery_tariff_id">
                                    <option v-for="tariff in delivery_types[delivery_zone.delivery_type_id].tariffs"
                                            :value="tariff.id"
                                            v-text="tariff.name"
                                    ></option>
                                </select>
                            </div>
                            <div class="col-md-2">
                                <input type="number" min="0"
                                       class="form-control input-sm"
                                       v-model="delivery_zone.tax"
                                       step="0.01"
                                       :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][tax]`"
                                />
                            </div>
                            <div class="col-md-1">
                                <input type="number" min="0"
                                       class="form-control input-sm"
                                       v-model="delivery_zone.sorting"
                                       :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][sorting]`"
                                />
                            </div>
                            <div class="col-md-1">
                                <input type="number" min="0"
                                       class="form-control input-sm"
                                       v-model="delivery_zone.min_delivery_days"
                                       :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][min_delivery_days]`"
                                />
                            </div>
                            <div class="col-md-1">
                                <input type="number" min="0"
                                       class="form-control input-sm"
                                       v-model="delivery_zone.max_delivery_days"
                                       :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][max_delivery_days]`"
                                />
                            </div>
                            <div class="col-md-1">
                                <input type="checkbox"
                                       value="1"
                                       v-model="delivery_zone.is_active"
                                       :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][is_active]`"
                                />
                            </div>
                          <div class="col-md-1">
                                <input type="checkbox"
                                       value="1"
                                       v-model="delivery_zone.only_stealth"
                                       :name="`payment_zones[${payment_index}][delivery_zones][${delivery_index}][only_stealth]`"
                                />
                            </div>
                            <div class="col-md-1">
                                <button type="button"
                                        class="btn btn-danger btn-xs"
                                        @click="removeDeliveryZone(payment_index, delivery_index)"
                                >
                                    <i class="fa fa-ban"></i>
                                </button>
                            </div>
                        </div>
                        <button type="button" class="btn btn-success btn-xs" @click="addDeliveryZone(payment_index)">
                            <i class="fa fa-plus"></i>
                            {{ translations.buttons.add }}
                        </button>
                        <hr>
                    </div>
                </div>
                <button @click="addPaymentZone()" type="button" class="btn btn-success btn-md">
                    <i class="fa fa-plus"></i>
                    {{ translations.buttons.add }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ["translations", "payment_types", "delivery_types", "location_id", "tax_types", "currencies"],
        data() {
            return {
                editing_payment_zones: [],
            };
        },
        mounted() {
            Vue.http.headers.common['X-CSRF-TOKEN'] = document.querySelector('#token').getAttribute('content');
        },
        created() {
            if (this.location_id) {
                this.loadPaymentZones();
            }

            this.editing_payment_zones = [];
        },
        methods: {
            loadPaymentZones() {
                this.$http.get(`/shop/locations/${this.location_id}/data`).then((response) => {
                    console.log(response.data);
                    this.editing_payment_zones = response.data.payment_zones;
                    console.log(this.editing_payment_zones);
                });
            },
            addPaymentZone() {
                this.editing_payment_zones.push({
                    tax: 0,
                    sorting: 0,
                    is_active: 0,
                    only_stealth: 0,
                    delivery_zones: [],
                    tax_type: this.tax_types[0],
                    currencies: this.currencies[0],
                    payment_type_id: Object.keys(this.payment_types)[0],
                    price_limit: 0,
                    price_limit_currency: 0,
                    seeds_count_limit: 0,
                });
            },
            removePaymentZone(index) {
                this.editing_payment_zones.splice(index, 1);
            },
            addDeliveryZone(paymentIndex) {
                let paymentZone = this.editing_payment_zones[paymentIndex];

                this.editing_payment_zones[paymentIndex].delivery_zones.push({
                    tax: 0,
                    sorting: 0,
                    is_active: 0,
                    only_stealth: 0,
                    currencies: this.currencies[0],
                    payment_type_id: paymentZone.payment_type_id,
                    delivery_type: Object.keys(this.delivery_types)[0],
                    price_limit_currency: 0,
                });
            },
            removeDeliveryZone(paymentIndex, deliveryIndex) {
                this.editing_payment_zones[paymentIndex].delivery_zones.splice(deliveryIndex, 1);
            }
        }
    }
</script>
